import { Flex, FlexProps, Text, TextProps } from '@applyboard/crystal-ui';

type LabelValueProps = {
  label: string;
  variant?: TextProps['variant'];
  color?: TextProps['intent'];
  icon?: React.ReactNode;
  value: string | React.ReactNode;
  labelVariant?: TextProps['variant'];
  gap?: FlexProps['gap'];
};
export function LabelValue(props: LabelValueProps) {
  const { label, variant = 'bodyM', color, value, icon, labelVariant = 'labelM', gap } = props;
  return (
    <Flex direction="column" aria-describedby={label} role="term" gap={gap}>
      <Text id={label} variant={labelVariant || 'labelM'} contrast="low">
        {label.toUpperCase()}
      </Text>
      <Flex gap={1} align="center">
        {icon}
        <Text variant={variant} intent={color} contrast="mid">
          {value}
        </Text>
      </Flex>
    </Flex>
  );
}
